import React from 'react';
import './SelectedGoal.css';
import './Goals.css';
import './SelectedSevenGoal.css';

function formatGoalDate(dateValue) {
    if (!dateValue) return '';
    const date =
        dateValue instanceof Date ? dateValue : new Date(dateValue);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
}

const SelectedSevenGoal = (props) => {
    const isPicked = props.itemF.selected === true;
    const areaColor =
        props.AllState.SelectedGoalsGroup[props.number].Fs.color;
    const formattedDate = formatGoalDate(props.itemF.date);

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={() =>
                props.selectGoal(
                    props.indexF,
                    props.number,
                    props.itemF.selected,
                    props.itemF.idL
                )
            }
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    props.selectGoal(
                        props.indexF,
                        props.number,
                        props.itemF.selected,
                        props.itemF.idL
                    );
                }
            }}
            className={`selectedGoalCard__container pick7GoalCard${
                isPicked ? ' pick7GoalCard--picked' : ' pick7GoalCard--unpicked'
            }`}
            aria-pressed={isPicked}
            style={{ '--pick7-area-color': areaColor }}
        >
            <div className="pick7GoalCard__numberCol">
                <span
                    className="pick7GoalCard__check"
                    aria-hidden={!isPicked}
                >
                    {isPicked ? '✓' : ''}
                </span>
                <h5 className="heading-5 pick7GoalCard__number">
                    {props.indexF + 1}
                </h5>
            </div>
            <div className="pick7GoalCard__textCol">
                <p className="pick7GoalCard__text">{props.itemF.text}</p>
            </div>
            <div className="pick7GoalCard__dateCol">
                <span className="pick7GoalCard__date">{formattedDate}</span>
            </div>
        </div>
    );
};

export default SelectedSevenGoal;
